<template>
  <module
      ref="module"
      titleIcon="fa fa-details"
      :title="`${$t('strategytxt')} ${$t('detailstxt')}`"
      :use-default-list="false"
    >
    <div v-if="inprogress" class="text-center text-black my-5">
      <h4>{{ inprogresstxt }} {{ $t('strategytxt') }}. {{ $t('pleasewait') }}</h4>
      <i class="fa fa-spinner fa-spin fa-fw" style="font-size: 60px;"></i>
    </div>
    <div slot="global">
      <div v-if="inprogress" class="text-center text-black my-5">
        <h4>{{ inprogresstxt }} {{ $t('strategytxt') }}. {{ $t('pleasewait') }}</h4>
        <i class="fa fa-spinner fa-spin fa-fw" style="font-size: 60px;"></i>
      </div>
      <div v-else >
        <strategy-header
          hide-buttons
          :logo="logo_login"
          :name="strategy.name"
          :likes="strategy.likes"
          :price="strategy.price"
          :subtitle-l1="subtitleL1"
          :subtitle-l2="subtitleL2"
          :is-wl-session="isWlSession"
          :settings="settings"
          :force-show="forceShowTrades"
          :last-update="exposure.myDate"
        />
        <strategy-charts :account="account" :settings="settings" :force-show="forceShowTrades" />
        <strategy-statistics :exposure="exposure"/>
        <account-trades-table v-if="forceShowTrades || settings.show_open_trades" type="open" :account="account" />
        <account-trades-table v-if="forceShowTrades || settings.show_trade_history" type="history" :account="account" />
      </div>
    </div>
  </module>
</template>

<script>
import CardWrapper   from './CardWrapper.vue';
import StrategyHeader     from './StrategyHeader.vue';
import StrategyCharts from './StrategyCharts.vue';
import StrategyStatistics from './StrategyStatistics.vue';
import AccountTradesTable from "./AccountTradesTable.vue";

export default {
  name: 'PublicStrategyInfo',
  components: {
    AccountTradesTable,
    CardWrapper,
    StrategyHeader,
    StrategyCharts,
    StrategyStatistics,
  },
  computed: {
    logo_login() {
      return this.settings.logo_login || this.logo;
    },
    subtitleL1() {
      const mrt = `${this.$t('monthly_return')}: ${Math.round(this.exposure.monthlyReturn * 10000) / 100 || 0}%`
      const foc = this.settings.show_trade_history || this.settings.forceShow ? `| ${this.$t('focus')}: ${this.exposure.focus || 0}`: ''
      return [mrt, foc, ].join(' ')
    },
    subtitleL2() {
      const bal = `${this.$t('balance')}: ${this.exposure.balance || 0} ${this.strategy.settings.currency}`
      const tpl = `| ${this.$t('total_pl')}: ${this.exposure.absoluteProfit || 0}`
      return [bal, tpl, ].join(' ')
    },
  },
  data() {
    return {
      inprogress: true,
      inprogresstxt: '',
      settings: {},
      isWlSession: false,
      fail_load_strategy: false,
      forceShowTrades: false,
      account: '',
      strategy: {
        id:    null,
        name:  '',
        price: '',
        settings: {},
        likes: 0,
      },
      exposure: {},
      form: {
        afl_id: null,
        wlId:   ''
      },
    };
  },
  methods: {
    failredirect: () => {
      this.fail_load_strategy = true;
      this.inprogress = false;
    },
    async loadStrategy() {
      try {
        let stratdata = localStorage.getItem('_tmp-sid-account');
        if (stratdata) {
          stratdata = JSON.parse(stratdata);
          this.strategy = {
            "id": stratdata.sid,
            "name": stratdata.sname,
            "price": stratdata.price,
          };
          this.forceShowTrades = stratdata.forceShowTrades;
          this.account = stratdata.account;
        }
        let { settings } = await this.$getPublicStrategySettings(this.strategy.id);
        this.strategy.settings = settings;
        let { likes } = await this.$getPublicStrategyLikes(this.strategy.id);
        this.strategy.likes = likes;
        this.exposure = (await this.$getPublicStrategyExposure(this.account)).data || {};
        this.form.afl_id = this.strategy.affiliateID;
        this.inprogress = false;
      } catch {
        this.failredirect();
      }
    },
    applySettings(resp) {
      if (!resp.success) return this.applyDefaultBackground();
      this.isWlSession = true;
      this.settings = resp.data;
      document.body.style.backgroundColor = this.settings.bgcolor;
      if (this.settings.bgimg_login) {
        document.body.style.backgroundImage = `url('${this.settings.bgimg_login}')`;
      }
      try {
        const icon = this.settings.whitelabel.toLowerCase();
        ['favicon16','favicon32','favicon96'].forEach(id =>
          document.getElementById(id).href = `/static/img/icons/${icon}.ico`
        );
        document.title = this.settings.fullname;
      } catch {}
    },
    applyDefaultBackground() {
      this.isWlSession = false;
      document.body.style.backgroundColor = '#D4FC8C';
    }
  },
  async mounted() {
    this.inprogresstxt = this.$t('loadingtxt');
    await this.loadStrategy();

    const wl = this.$route.params.wl || window.location.hostname;
    this.form.wlId = wl;

    await this.$wlSettings(wl).then(
      resp => this.applySettings(resp),
      ()   => this.applyDefaultBackground()
    );

    document.body.classList.remove('tab-space');
  },
  created() {
    this.$setTranslatingInProgress()
  },
  beforeDestroy() {
    document.body.classList.remove('nav-open','off-canvas-sidebar');
    this.$root.$off("showTranslatingProgress")
  },
  destroyed() {
    localStorage.removeItem('_tmp-sid-account');
  }
};
</script>

<style scoped>

</style>
